<script>
    import { onMount } from "svelte"
    import { firebase, firestore } from "../firebase/firebase.js";
    import BorderLoader from "../components/BorderLoader.svelte"
    import GrowLoader from "../components/GrowLoader.svelte"
    import { navigateTo, Navigate } from 'svelte-router-spa';
    import EmptyText from "../components/EmptyText.svelte"
    import { user, userProfile } from "../store/auth.js"
    export let currentRoute;
    export let params;

    var isUserAdmin = false;
    var ads = [];
    var loader = false;

    $: {
        if ($user && $userProfile) {
            isUserAdmin = $userProfile.role == 'admin' ? true : false;
            init();
        }
    }

    onMount(() => {
        if ($user && $userProfile) {
            isUserAdmin = $userProfile.role == 'admin' ? true : false;
            init();
        }
    })

    async function init() {
        if (isUserAdmin) {
            await fetchInAppAds();
        }
    }

    async function fetchInAppAds() {
        loader = true;
        ads = [];
        var res = await firestore.collection('in-app-ads').orderBy('created_at', 'desc').get();
        if (res && res.docs && res.docs.length != 0) {
            ads = res.docs;
        }
        loader = false;
    }

    async function newInAppAd() {
        navigateTo('/admin/in-app-ads/new')
    }

</script>

<div class="wrapper">
    {#if isUserAdmin}
<div class="my_header">
    <div>
        In-App Advertizement
    </div>
    <div class="d-flex">
        <Navigate to="/admin/in-app-ads/new"><button type="button" class="btn btn-outline-primary btn-sm">NEW</button></Navigate>
    </div>
</div>
    <div class="row no-gutters w-100 justify-content-center align-items-center flex-column">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pb-5">
            <div class="row no-gutters">
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead class="thead-light">
                        <tr>
                            <th scope="col">Title</th>
                            <th scope="col">ioss URL</th>
                            <th scope="col">Android URL</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            {#if !loader}
                                {#if ads && ads.length != 0}
                                    {#each ads as ad}
                                        <tr>
                                            <td >{ad.data()['title']} </td>
                                            <td class="fixed-td">
                                                <a target="_blank" href="{ad.data()['ios_url']}">{ad.data()['ios_url']}</a>
                                            </td>
                                            <td class="fixed-td">
                                                <a target="_blank" href="{ad.data()['android_url']}">{ad.data()['android_url']}</a>
                                            </td>
                                            <td>
                                                <span class:badge="{true}" class:badge-info="{!ad.data()['is_disabled']}" class:badge-dark="{ad.data()['is_disabled']}">{ad.data()['is_disabled'] ? 'Disabled' : 'Active' }</span>
                                            </td>
                                            <td>
                                                <div class="d-flex justify-content-center">
                                                    <Navigate to="{'/admin/in-app-ads/' + ad.id}"><button type="button" class="btn btn-outline-primary btn-sm"><span class="fa fa-eye "></span></button></Navigate>
                                                </div>
                                            </td>
                                        </tr>
                                    {/each}
                                {:else}
                                    <tr>
                                        <td colspan="6"><EmptyText msg="No ads" /></td>
                                    </tr>
                                {/if}
                            {:else}
                                <tr>
                                    <td colspan="6"><GrowLoader /></td>
                                </tr>
                            {/if}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>        
    </div>
{/if}
</div>
<style>
    .wrapper{
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .fixed-td{
        max-width: 270px !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
        overflow: hidden !important;
    }

    table,
    thead,
    tr,
    tbody,
    th,
    td {
    text-align: center;
    vertical-align: middle;
    }

    .table td {
    text-align: center;
    }
    .my_header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
</style>